import { get } from './index.js'

// 获取精选产品   
export const getFeaturedProducts = async () => {
  try {
    const response = await get('/product/hot')
    console.log('API响应:', response)
    
    // 提取records数组，如果存在的话
    if (response && response.records && Array.isArray(response.records)) {
      return response.records
    }
    
    // 如果响应本身就是数组，直接返回
    if (Array.isArray(response)) {
      return response
    }
    
    // 如果响应是对象但没有records字段，记录警告并返回空数组
    console.warn('API响应格式不符合预期，期望records数组，实际:', response)
    return []
    
  } catch (error) {
    console.error('获取精选产品失败:', error)
    return []
  }
}

// 获取产品列表（支持分类和分页）
export const getProducts = (params = {}) => {
  return get('/product', params)
}



// 获取产品详情
export const getProductById = (id) => {
  return get(`/products/${id}`)
}

// 获取产品详情（新命名方式，与ProductDetail组件兼容）
export const getProductDetail = (id, locale = '') => {
  const localeParam = locale ? `&locale=${locale}` : ''
  return get(`/product/detail?productId=${id}${localeParam}`)
}

// 获取产品分类
export const getCategories = () => {
  return get('/product/type')
}

// 搜索产品
export const searchProducts = (params = {}) => {
  return get('/products/search', params)
}

export default {
  getFeaturedProducts,
  getProducts,
  getProductById,
  getProductDetail,
  getCategories,
  searchProducts,
}